const FIXED_URLS: Record<string, string> = {
    local: "https://dev.app.yedalabs.io",
    dev: "https://dev.app.yedalabs.io",
    prod: "https://app.yedalabs.io",
};

/**
 * @param fixed - Always returns the canonical domain for the current environment (ignores VERCEL_URL).
 *                Local env falls back to dev. Use for external services that need a publicly reachable URL.
 */
export function getBaseUrl({ fixed }: { fixed?: boolean } = {}): string {
    if (fixed) {
        const env = process.env.NEXT_PUBLIC_ENV || "local";
        return FIXED_URLS[env];
    }

    if (typeof window !== "undefined") {
        return `${window.location.protocol}//${window.location.host}`;
    }

    if (process.env.VERCEL_URL) {
        return `https://${process.env.VERCEL_URL}`;
    }

    return "http://localhost:3000";
}
